import * as actionTypes from "./serviceCallTypes";

const INITIAL_STATE = {
    serviceCallList: [],
    attachmentList: [],
    equipmentList: [],
    problemList: [],
};

const serviceCallReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SET_SERVICE_CALL_LIST:
            return {
                ...state,
                serviceCallList: action.payload.list,
            };
        case actionTypes.SET_EQUIPMENT_LIST:
            return {
                ...state,
                equipmentList: action.payload.list,
            };
        case actionTypes.SET_PROBLEM_LIST:
            return {
                ...state,
                problemList: action.payload.list,
            };
        case actionTypes.SET_SUB_PROBLEM_LIST:
            return {
                ...state,
                subProblemList: action.payload.list,
            };
        default:
            return state;
    };
};

export default serviceCallReducer;